import { useMemo } from 'react';
import { getItemByIdOrThrow } from 'src/utils';
import { useScene } from 'src/hooks/useScene';

export const useRectangle = (id?: string) => {
  const { rectangles } = useScene();

  const rectangle = useMemo(() => {
    if (!id || !rectangles || rectangles.length === 0) {
      console.warn(`Invalid rectangle ID or empty rectangles array: ${id}`);
      return null;
    }

    try {
      return getItemByIdOrThrow(rectangles, id).value;
    } catch (error) {
      console.warn(`Rectangle not found: ${id}`, error);
      return null;
    }
  }, [rectangles, id]);

  return rectangle;
};
